import script from "./WorkorderDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkorderDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WorkorderDialog.vue?vue&type=style&index=0&id=4a87e6f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a87e6f8"]])

export default __exports__